/**
 * 上报组件
 * 只有在正式环境下才会上报
 * 避免上报数据不准确
 */
import Cookies from 'js-cookie';
import get from 'lodash/get';
import store from '@/store';

function Stat(data) {
  const statdata = JSON.parse(localStorage.getItem('statInfo'));
  const userdata = JSON.parse(localStorage.getItem('userInfo'));
  if (data.timeReport) {
    localStorage.setItem('startTime', new Date().getTime());
  }
  const params = {
    openid: Cookies.get('openid'),
    unionid: Cookies.get('unionid'),
    ktvid: get(statdata, 'ktvid'),
    roomid: get(statdata, 'room_id'),
    roomip: get(statdata, 'room_ip'),
    fr: get(statdata, 'user_scan_fr'),
    tp: data.tp,
    desc: data.desc,
    isolduser: get(userdata, 'is_old_user'),
    str10: store.state.role,
  };
  let code = '';

  code = Object.keys(params).reduce((prev, curKey) => {
    prev = `${prev}${curKey}=${params[curKey]}&`;
    return prev;
  }, '');
  if (process.env.NODE_ENV === 'production') {
    try {
      let img = new Image(1, 1);
      img.src = `${process.env.VUE_APP_STATURL}?${code}${get(statdata, 'stat')}&_r=${Math.random()}`;
      img.onload = () => {
        img = null;
      };
    } catch (err) {
      // eslint-disable-next-line
      console.log(err)
    }
  }
}
export default Stat;
